import {
  makeStyles,
  Typography,
  Button,
  ButtonProps,
} from "@material-ui/core";
import { ITheme, colours, theme } from "../constants/theme";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";

interface IProps extends ButtonProps {
  title: string;
}

export const PrimaryTextButton = (props: IProps) => {
  const classes = useStyles();
  return (
    <Button className={classes.button} {...props}>
      <Typography variant="button" component="p" style={{ color: props.disabled ? theme.palette.text.disabled : colours.primary }}>
        {props.title}
      </Typography>
    </Button>
  );
};

const useStyles = makeStyles((theme: ITheme) => ({
  button: {
    minWidth: 64,
    height: 36,
    borderRadius: 8,
    padding: "6px 8px",
    ...textButtonHoverAndActive
  },
  disabled: {
    minWidth: 64,
    height: 36,
    borderRadius: 8,
    padding: "6px 8px",
  }
}));